import { cn } from "@/lib/utils";
import { Card, CardContent } from "../ui";

const UserDataCard = ({ card }: { card: any }) => {
  return (
    <Card className="rounded-xl shadow-xl relative overflow-hidden transition-all hover:scale-105 hover:shadow-2xl cursor-pointer p-0">
      <CardContent className="flex p-0 bg-primary">
        <div className="flex flex-row w-full items-center justify-between bg-white p-5 mb-2 rounded-l rounded-b-xl">
          <div className="bg-g-50 rounded-[5px] p-3">
            {card.icon ? (
              <card.icon className="h-10 w-10 stroke-primary" />
            ) : (
              <></>
            )}
          </div>
          <div className="flex flex-col items-end">
            <span
              className={cn(
                "text-primary text-[24px] font-[500] text-end",
                card?.subTitle?.toLowerCase() == "position"
                  ? "w-full break-all"
                  : ""
              )}
            >
              {card?.title}
            </span>
            <span className="text-g-300 text-[12px] font-[400]">
              {card?.subTitle}
            </span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default UserDataCard;
